import { Component, OnDestroy, OnInit } from '@angular/core';
import { Exception, PaymentMethods } from '@cargos/sprintpay-models';
import { Observable, Subject, map, of, switchMap, takeUntil } from 'rxjs';
import { LogoPaymentMethodComponent } from 'src/app/shared/components';
import { SanitizerPipe } from 'src/app/shared/pipes';
import { PaymentMethodsService } from 'src/app/shared/services';
import { FeatureRestrictionsService } from 'src/app/shared/services/features/feature-restrictions.service';
import { CargoCreditComponent } from '../../cart/payment-methods/method-cargo-credit/cargo-credit.component';
import { AwbSubscriptionService } from '../services/awb-subscription.service';

@Component({
    selector: 'app-auto-pay-cargo-credit',
    standalone: true,
    imports: [LogoPaymentMethodComponent, CargoCreditComponent, SanitizerPipe],
    templateUrl: './auto-pay-cargo-credit.component.html',
    styleUrl: './auto-pay-cargo-credit.component.scss',
})
export class AutoPayCargoCreditComponent implements OnInit, OnDestroy {
    public cargoCredit: {
        isValid: boolean;
        exception?: Exception | undefined;
        availableCredit?: boolean | undefined;
        invalidPaymentMethod?: boolean | undefined;
    } | null;
    public paymentMethodsEnum = PaymentMethods;
    public isAccountOnHold: boolean;

    private unsubscribe$: Subject<void>;
    constructor(
        private paymentMethodsService: PaymentMethodsService,
        private featureRestrictionsService: FeatureRestrictionsService,
        private awbSubscriptionService: AwbSubscriptionService
    ) {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        this.subscribePaymentMethods();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    subscribePaymentMethods(): void {
        this.getAccountOnHold()
            .pipe(
                switchMap((isAccountOnHold) => {
                    if (!isAccountOnHold) {
                        return this.getPaymentMethods().pipe(
                            map((cargoCredit) => ({
                                isAccountOnHold,
                                cargoCredit,
                            }))
                        );
                    }
                    return of({
                        isAccountOnHold,
                        cargoCredit: null,
                    });
                }),
                takeUntil(this.unsubscribe$)
            )
            .subscribe({
                next: ({ isAccountOnHold, cargoCredit }) => {
                    this.cargoCredit = cargoCredit;
                    this.isAccountOnHold = isAccountOnHold;
                },
            });
    }

    getPaymentMethods(): Observable<{
        isValid: boolean;
        exception?: Exception;
        availableCredit?: boolean;
        invalidPaymentMethod?: boolean;
    }> {
        return this.paymentMethodsService.getCargoCreditBalance().pipe(
            map((cargoCredit) => {
                this.awbSubscriptionService.setEnabledCargoCredit(!cargoCredit.invalidPaymentMethod);
                this.awbSubscriptionService.setEnoughCargoCredit(cargoCredit?.availableCredit || false);
                return cargoCredit;
            })
        );
    }

    getAccountOnHold(): Observable<boolean> {
        return this.featureRestrictionsService.isAccountOnHold();
    }
}
